import { atom } from 'jotai';
import { TeamMember, TeamMembersPrivateNotes } from '../typings';
import { createRequestAtom } from '../../../../shared/utils/request-atom';

export const teamMembersAtom = createRequestAtom<TeamMember[]>();

export const teamMembersPrivateNotesAtom = createRequestAtom<TeamMembersPrivateNotes>();

export const shouldRefreshteamAtom = atom(false);
